import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { _participants } from 'store/selectors/Room'

import { filterKeys } from '../../constants'

const sortAlphabetically = (participant1, participant2) => {
    let result = 0

    if (participant1.name < participant2.name) result = -1
    else if (participant1.name > participant2.name) result = 1

    return result
}

const sortByPropertyOn = (array, property) => {
    array.sort((item1, item2) => item1[property] - item2[property])
    return array
}

const sortElsewhereFirst = (participant1, participant2) =>
    participant2.isElsewhere - participant1.isElsewhere

const useParticipantsFilter = selectedFilter => {
    const participants = useSelector(_participants)

    const [filteredParticipants, setFilteredParticipants] = useState([
        ...participants,
    ])

    useEffect(() => {
        switch (selectedFilter) {
            case filterKeys.DEFAULT:
                setFilteredParticipants([...participants])
                break
            case filterKeys.ALPHABETICAL:
                const temp = [...participants]
                temp.sort(sortAlphabetically)
                setFilteredParticipants(temp)
                break
            case filterKeys.RAISED_HAND:
                setFilteredParticipants([...participants])
                break
            case filterKeys.VIDEO_OFF_FIRST:
                const videoOff = [...participants]
                sortByPropertyOn(videoOff, 'isVideoEnabled')
                setFilteredParticipants([...videoOff])
                break
            case filterKeys.AUDIO_OFF_FIRST:
                const audioOff = [...participants]
                sortByPropertyOn(audioOff, 'isAudioEnabled')
                setFilteredParticipants([...audioOff])
                break
            case filterKeys.ELSEWHERE:
                const elseWhere = [...participants]
                elseWhere.sort(sortElsewhereFirst)
                setFilteredParticipants([...elseWhere])
                break
            default:
                break
        }
    }, [selectedFilter, participants])

    return filteredParticipants
}

export default useParticipantsFilter
